import React from "react";
import { Flex } from "@radix-ui/themes";

export function BrazeMark({ size = 40 }) {
  return (
    <Flex
      align="center"
      justify="center"
      aria-label="Braze"
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        padding: size * 0.2,
        boxSizing: "border-box",
        borderRadius: "var(--space-1)",
        background: "#FFFFFF",
        border: "1px solid var(--gray-a6)",
      }}
    >
      <img
        src={require("../../../assets/images/braze.png")}
        alt="Braze"
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </Flex>
  );
}
